export const SEGMENT_OPTIONS = {
  "Dry Clean": ["Standard", "Premium"],
  Tailoring: ["Standard", "Designer"],
};

export const getSegment = (s) => {
  const opts = SEGMENT_OPTIONS[s.category];
  if (!opts) return null;
  for (const opt of opts) {
    if (s.name.endsWith(` · ${opt}`)) return opt;
  }
  return null;
};

const PRESS_SUFFIXES = ["Standard press", "Steam press"];

export const displayName = (s) => {
  const segment = getSegment(s);
  if (segment) return s.name.slice(0, -(segment.length + 3));
  if (s.category === "Press") {
    for (const suf of PRESS_SUFFIXES) {
      const suffix = ` · ${suf}`;
      if (s.name.endsWith(suffix)) return s.name.slice(0, -suffix.length);
    }
  }
  return s.name;
};

export const getItemTag = (s) => {
  const segment = getSegment(s);
  if (segment) return segment;
  if (s.category === "Press" && s.description === "Steam finish") return "Steam finish";
  return null;
};

// A per-item sale price always wins; otherwise the store-wide % off applies (mirrors backend build_items).
export const effectivePrice = (s, shop) => {
  if (s.sale_price != null && s.sale_price < s.price) return s.sale_price;
  if (shop?.store_discount_active && (shop.store_discount_percent ?? 0) > 0) {
    return Math.round(s.price * (1 - shop.store_discount_percent / 100) * 100) / 100;
  }
  return s.price;
};
